import {useGetData} from "../pages-lib/rewards/model";
import {useUpdateHeaderTitle, usePermission} from "../hooks";
import React from "react";
import {ExtraButtons} from "../components/extra-buttons";
import {Header} from "../components/layout/header";
import {VisibilityProvider} from "../components/visibility-provider";
import {EditDrawer} from "../pages-lib/rewards/edit-drawer";
import {useManageItems} from "../pages-lib/rewards/model/use-manage-items";
import styled from "styled-components";
import {Table as AntTable} from "antd";
import {getColumns} from "../pages-lib/rewards/table-columns";
import {TableSearch} from "../components/table-search";

export default function Rewards() {
    const { hasPermission } = usePermission()
    const [createDrawerState, setCreateDrawerState] = React.useState(false)
    const [editDrawerState, setEditDrawerState] = React.useState(false)


    const {
        dataItems,
        dataItemsColumns,
        isLoading,
        pagination,
        handleTableChange,
        handleSearchTable,
        refetch: getItems,
        options
    } = useGetData();

    const {
        editData,
        onSaveEdit,
        onCreate,
        onDelete,
        onEditItem
    } = useManageItems(dataItems, getItems, onSuccessEdit, onSuccessCreate)

    const columns = getColumns(hasPermission("rewards.edit") ? onEditItem : null, hasPermission("rewards.delete") ? onDelete : null)
    function onSuccessEdit() {
        setEditDrawerState(!editDrawerState)
    }

    function onSuccessCreate() {
        setCreateDrawerState(!createDrawerState)
    }

    const headerTitle = useUpdateHeaderTitle({
        items: dataItems,
        defaultTitle: "0 Наград",
        arrType: ["Награда", "Награды", "Наград"],
    })
    return (
        <>
            <Header
                title={headerTitle}
                extra={
                    <ExtraButtons
                        onCreate={hasPermission("rewards.create") ? () => setCreateDrawerState(true) : undefined}
                        // onFilter={() => setFilterDrawerState(!filterDrawerState)}
                        // onSort={() => setSortableDrawerState(!sortableDrawerState)}
                        titles={{ onCreate: "Добавить награду" }}
                    />
                }
            />

            <TableSearch handleSearch={handleSearchTable} placeholder={"Поиск по ID или названию"} />

            <StyledTable
                dataSource={dataItemsColumns}
                columns={columns}
                loading={isLoading}
                onChange={handleTableChange}
                pagination={pagination}
            />

            {hasPermission("rewards.create") && (
                <VisibilityProvider visible={createDrawerState}>
                    <EditDrawer
                        title={"Создать награду"}
                        initialValues={false}
                        onClose={() => setCreateDrawerState(false)}
                        onSave={onCreate}
                        rewardTypeOptions={options.rewardTypesOptions}
                        eventOptions={options.eventOptions}
                    />
                </VisibilityProvider>
            )}

            {hasPermission("rewards.edit") && (
                <VisibilityProvider visible={editDrawerState}>
                    <EditDrawer
                        title={"Редактировать награду"}
                        initialValues={editData}
                        onClose={() => setEditDrawerState(false)}
                        onSave={onSaveEdit}
                        rewardTypeOptions={options.rewardTypesOptions}
                        eventOptions={options.eventOptions}
                    />
                </VisibilityProvider>
            )}
        </>
    )
}


const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
`
